import getters from './getters'
import actions from './actions'
import mutations from './mutations'

const state = {
    isLoading: {
        data: false,
        volumes: false,
        summary: false,
        breakdown: false,
        cclone: {
            chart: false,
            list: false
        }
    },
    expandedNodesIds: [],
    bucket: {},
    currentCriterionPath: null,
    currentCriterionName: '',
    focusedBox: {
        type: 'inclusion',
        index: 0
    },
    lastUuRequestKey: {
        volumes: null,
        summary: null,
        breakdown: null
    },
    formula: {
        inclusion: [
            {
                criteria: [],
                volume: {
                    total_doc: null,
                    total_mobile: null,
                    total_desktop: null,
                    total_xdevice: {}
                },
                isDisabled: false
            }
        ],
        exclusion: [],
        cclone: null,
        path: [],
        criteriaSelected: null

    },
    formulaSettings: {
        defaultSettings: {
            profile: 'desktop',
            range: 10,
            recency: 30,
            level: 0,
            throttling: 'sampling'
        },
        settings: {
            profile: null,
            range: null,
            recency: null,
            level: null,
            throttling: null
        },
        settingsType: null
    },
    menuCriteriaType: null,
    criterionSettings: {
        settingType: null
    },
    formAudience: {
        display: false,
        activeTabFormAudience: 'audienceDetails',
        action: 'create',
        mode: null
    },
    metrics: {
        summary: null,
        breakdown: null,
        volumes: null,
        settings: {},
        activeTabBuilder: 'volumes'
    },
    cclone: {
        activeTab: 'information'
    },
    displayModal: {
        warning: false,
        formulaIsNotEmpty: false,
        formulaHasNoAvailableCriteria: false,
        formulaHasOnlyDeletedCriteria: false
    },
    volumeType: 'ID based',
    isEditingAudience: false,
    audienceInEdition: {},
    nextAudienceInEdition: {}
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
